import MaintenancePage from "./maintenance-page";

export default MaintenancePage;
